import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

//COMPONENTS
import ShopRouter from "./files/shop/podRouter";
import ProfileRouter from "./files/profile/podRouter";

//ACTIONS
import * as AccessModalActions from "../../../envStore/actions/accessModal";
import * as PrintingShopActions from "../../../envStore/actions/3dPrintingShop";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        if (user.requestedPassword) {
            dispatch(AccessModalActions.UpdateScreen("changePassword"));
        }
        dispatch(PrintingShopActions.UpdateBasketItemTotal());
        setIsLoaded(true);
    });

    return (
        <div style={{ minHeight: "92vh" }}>
            {isLoaded && (
                <div style={{ minHeight: "100%" }}>
                    <Routes>
                        <Route path={"/*"} element={<ShopRouter />} />
                        <Route path={"/profile/*"} element={<ProfileRouter />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
